export default "__VITE_ASSET__CkXpjFR1__"